import { SvgIcon, SvgIconProps } from "@mui/material";
import React from "react";

export const MenuIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props}>
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="#8F95B2"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8 7.94967H16.9C18.1 5.54967 18.7 4.14967 19 3.64967C19.3 3.04967 19.3 2.34967 19.1 1.64967C18.8 1.04967 18.2 0.44967 17.6 0.249671C16.2 -0.35033 14.7 0.14967 14.1 1.54967C13.1 3.64967 12 5.84967 11 7.94967H0.8C0.4 7.94967 0 8.24967 0 8.74967C0 13.0497 2.6 16.9497 6.6 18.5497C6.6 18.5497 6.9 18.8497 7.1 20.3497C7.1 20.7497 7.5 21.0497 7.8 21.0497H13.7C14.1 21.0497 14.4 20.7497 14.4 20.3497C14.4 19.2497 14.6 18.8497 14.6 18.7497C18.7 17.1497 21.4 13.1497 21.4 8.84967C21.6 8.24967 21.2 7.94967 20.8 7.94967ZM15.4 2.14967C15.8 1.24967 16.7 1.44967 17 1.54967C17.4 1.74967 17.5 2.04967 17.6 2.14967C17.7 2.44967 17.7 2.74967 17.6 2.94967C17.4 3.44967 16.6 5.04967 15.2 7.84967H12.6C13.5 6.04967 14.5 4.04967 15.4 2.14967ZM14.1 17.2497C13.5 17.4497 13.2 18.1497 13.1 19.4497H8.5C8.3 18.0497 7.9 17.3497 7.3 17.1497C4.1 15.8497 1.9 12.8497 1.6 9.44967H11.4C11.4 9.44967 11.4 9.44967 11.5 9.44967H11.6H15.7H20.1C19.7 12.9497 17.4 15.9497 14.1 17.2497Z"
      />
      <path
        d="M7.2999 13.2496C7.0999 12.9496 6.8999 12.5496 6.6999 12.0496C6.5999 11.5496 6.1999 11.3496 5.7999 11.4496C5.3999 11.5496 5.1999 11.9496 5.2999 12.3496C5.4999 13.0496 5.7999 13.6496 6.0999 14.0496C6.3999 14.4496 6.8999 14.8496 7.2999 15.2496C7.4999 15.4496 7.5999 15.4496 7.7999 15.4496C7.9999 15.4496 8.2999 15.3496 8.3999 15.1496C8.5999 14.8496 8.5999 14.3496 8.2999 14.1496C7.8999 13.8496 7.5999 13.5496 7.2999 13.2496Z"
      />
    </svg>
  </SvgIcon>
);
